import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, DataTableColumns, HStack } from '@tq/ui-components';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';
import { AuditRequest, AuditRequestStatus, ReportData } from 'types';
import { RequestDetails } from '../components/RequestDetails';
import { useFormatLocaleDate, StandardDateFormats } from 'config';

export const useTrafficMonitorColumns = (): DataTableColumns<ReportData>[] => {
  const { t } = useTranslation('traffic_monitor');
  const formatLocaleDate = useFormatLocaleDate();

  return [
    {
      accessor: 'date',
      Cell: (cellProps: { value: string }) =>
        formatLocaleDate(cellProps.value, StandardDateFormats.dateAndTime).toLowerCase(),
      disableSortBy: false,
      Header: () => t('date_time_call_header', 'Date & time of call'),
      width: 250,
    },
    {
      accessor: 'planningApplicationReferenceNo',
      Cell: (cellProps: { value: string }) => (
        <>
          <Box alignSelf='flex-start' marginRight={120} display='inline-flex'>
            {cellProps.value}
          </Box>
        </>
      ),
      Header: () => t('parn_header', 'Application reference number'),
      width: 200,
    },
    {
      accessor: 'apiCall',
      Cell: (cellProps: { value: string }) => (
        <>
          <Box alignSelf='flex-start' marginRight={20} display='inline-flex'>
            {cellProps.value}
          </Box>
        </>
      ),
      disableSortBy: false,
      Header: () => t('api_call_header', 'Type of API call'),
      width: 'auto',
    },
    {
      accessor: 'status',
      Cell: (cellProps: { value: AuditRequestStatus }) => (
        <HStack>
          <Box
            color={cellProps.value === 'Success' ? COLOURS.green[400] : COLOURS.red[400]}
            marginRight={2}
            fontSize={20}
            lineHeight={24}
          >
            {cellProps.value === 'Success' ? <FaCheckCircle /> : <FaTimesCircle />}
          </Box>
          <Box>
            {cellProps.value === 'Success' ? t('success', 'Success') : t('fail', 'Fail')}
          </Box>
        </HStack>
      ),
      Header: () => t('status_header', 'Status'),
      width: 200,
    },
    {
      accessor: 'httpCode',
      Cell: (cellProps: { value: string }) => (
        <>
          <Box alignSelf='flex-start' marginRight={2} display='inline-flex'>
            {cellProps.value}
          </Box>
        </>
      ),
      Header: () => t('httpcode_header', 'HTTP Code'),
      width: 200,
    },
    {
      accessor: 'msgDetail',
      Cell: ({ row: { original } }: CellProps<AuditRequest>) => (
        <RequestDetails details={original} />
      ),
      Header: () => t('detail_header', 'Details'),
      width: 200,
      disableSortBy: true,
    },
  ];
};
